import API from '@aws-amplify/api';
import Amplify from '@aws-amplify/api';
import Storage from '@aws-amplify/storage';

export const environment = {
    production: true,

    region: 'us-east-1',
    identityPoolId: 'us-east-1:41a4bc9a-2df8-4e1b-92b9-ae11bf999240',

    APILink : 'https://stg-api.eguard.us',
    // env : '/stg',
    env : '',

    // this is for s3
    // this will be how many attempts before s3 calls it quits
    s3attempts: 3,

    // if you can the userpoolid remember to change the end of teh login token :)
    userPoolId: 'us-east-1_Wt00r0Bj7',
    clientId: '2blu53bmm38rmha3vupnasuomi',
    bucket: 'stg-eguard-documents',
    stripeClientId : 'ca_D3DhcJryfdbrmapUXlop39GtD9aNIXtp',
    stripeKey: 'pk_test_y7imCudbrlg66ZDJQtnMWm5D00hkZlKw25',
    stripePublishableKey: 'pk_test_y7imCudbrlg66ZDJQtnMWm5D00hkZlKw25',
    loginKey: 'cognito-idp.us-east-1.amazonaws.com/us-east-1_Wt00r0Bj7',
    sts_endpoint: 'sts.us-east-1.amazonaws.com/us-east-1_Wt00r0Bj7',

    commentLink: 'https://1ijkoaj9zk.execute-api.us-east-1.amazonaws.com/dev/',
    casesLink: 'https://l1gwypxcec.execute-api.us-east-1.amazonaws.com/dev/',
    casesNewLink:'https://xppkgiijr4.execute-api.us-east-1.amazonaws.com/dev/',
    usersLink: 'https://stg-api.eguard.us/users/',
    stripeLink: 'https://zjcwkvygqc.execute-api.us-east-1.amazonaws.com/dev/',
    organizationsLink: 'https://stg-api.eguard.us/organization/',
    formsLink: 'https://1up51ukb1j.execute-api.us-east-1.amazonaws.com/dev/',
    todoLink: 'https://4o0wa162uh.execute-api.us-east-1.amazonaws.com/dev/',
    alertsLink: 'https://ihyj7y8rh8.execute-api.us-east-1.amazonaws.com/dev/',
    checkrLink: 'https://dbx2nxnm7e.execute-api.us-east-1.amazonaws.com/dev/',

    // ocr = vision
    ocrLink: 'https://stg-api.eguard.us/vision/',

    // notification
    activitiesLink: 'https://9qhsyh2la0.execute-api.us-east-1.amazonaws.com/dev/',
    plaidWebhook: 'https://stg-api.eguard.us/plaid/plaid/webhooks',
    plaidKey: '8b735142953cb8719458723968fbac',
    plaidLink: 'https://nqaiz4j7f5.execute-api.us-east-1.amazonaws.com/dev/',
    plaidEnv: 'sandbox',

    zillow: 'https://jizriohx58.execute-api.us-east-1.amazonaws.com/dev/',
    loginBucketName: 'login-pictures-stg',

    // Calendar Event
    calendarEventsLink: 'https://bzkykaumdh.execute-api.us-east-1.amazonaws.com/dev/',
    snackBarErrorLength: 10000,

    reports: 'https://knqwtwbfya.execute-api.us-east-1.amazonaws.com/dev/',
    preSign: 'https://t8xrmhanqj.execute-api.us-east-1.amazonaws.com/dev/',

    CASE_TRANSACTIONS: {
        TRANSACTIONS_BY_YEAR: 'https://stg-api.eguard.us/plaid/transactions/year/{year}/case/{case_id}/{account_id}',
        TRANSACTIONS_BY_DAY: 'https://stg-api.eguard.us/plaid/transactions/day/{days}/case/{case_id}/{account_id}'
    },
    PDF_DIFFERENCES_API: 'https://stg-api.eguard.us/vision/'

    
};

Amplify.configure({

    Storage: {
        AWSS3: {
            bucket: 'stg-eguard-documents', //REQUIRED -  Amazon S3 bucket
            region: 'us-east-1', //OPTIONAL -  Amazon service region
        }
    },
    API: {
        endpoints: [
            {
                name: "loginKey",
                endpoint:  "cognito-idp.us-east-1.amazonaws.com/us-east-1_Wt00r0Bj7"
            },
            {
                name: "casesLink",
                endpoint: environment.APILink + environment.env + "/cases/"
            },
            {
                name: "casesNewLink",
                endpoint:  environment.APILink + environment.env +  "/casesNew/"
            },
            {
                name: "commentLink",
                endpoint: environment.APILink + environment.env + "/comments/"
            },
            {
                name: "checkrLink",
                endpoint: environment.APILink + environment.env + "/checkr/"
            },
            {
                name: "usersLink",
                endpoint: environment.APILink + environment.env + "/users/"
            },
            {
                name: "stripeLink",
                endpoint: environment.APILink + environment.env + "/stripe/"
            },
            {
                name: "organizationsLink",
                endpoint: environment.APILink + environment.env + "/organization/"
            },
            {
                name: "formsLink",
                endpoint: environment.APILink + environment.env + "/forms/"
            },
            {
                name: "todoLink",
                endpoint: environment.APILink + environment.env + "/todo/"
            },
            {
                name: "alertsLink",
                endpoint: environment.APILink + environment.env + "/alerts/"
            },
            // ocr = vision
            {
                name: "ocrLink",
                endpoint: environment.APILink + environment.env + "/vision/"
            },
            {
                name: "activitiesLink",
                endpoint: environment.APILink + environment.env + "/notification/"
            },
            {
                name: "plaidWebhook",
                endpoint: environment.APILink + environment.env + "/plaid/plaid/webhooks"
            },
            {
                name: "plaidLink",
                endpoint: environment.APILink + environment.env + "/plaid/"
            },
            {
                name: "zillow",
                endpoint: environment.APILink + environment.env + "/zillow/"
            },
            // Calendar Event
            {
                name: "calendarEventsLink",
                endpoint: environment.APILink + environment.env + "/calendar/"
            },
            {
                name: "reports",
                endpoint: environment.APILink + environment.env + "/reports/"
            },
            {
                name: "preSign",
                endpoint: environment.APILink + environment.env + "/presign/"
            },
            {
                name: "PDF_DIFFERENCES_API",
                endpoint: environment.APILink + environment.env + "/vision/"
            },
            {
                name: "TRANSACTIONS_BY_YEAR", 
                endpoint: environment.APILink + environment.env + "/plaid/"
            },
            {
                name: "TRANSACTIONS_BY_DAY",
                endpoint: environment.APILink + environment.env + "/plaid/"
            },
            {
                name: "localForm",
                endpoint: "assets/forms/"
            },
            {
                name: "uploadLink",
                endpoint: ""
            }]
    }
});



// WEBPACK FOOTER //
// ./src/environments/environment.ts